module.exports = __webpack_public_path__ + "img/workspace1.a2ccd87a.png";